/**
 * External dependencies
 */
import jQuery from 'jquery';

/**
 * Internal dependencies
 */
import { processLayout } from './admin-calendar-layout.js';

/**
 * Popper implementation
 */
jQuery( function( $ ) {
	/**
	 * Scrolls to first booking on day view.
	 *
	 * @since 1.13.0
	 */
	 function scrollToFirstBooking() {
		// Day view and atleast one booking.
		if ( $( '.calendar_days' ).length && $( '.daily_view_booking' ).length ) {
			let previousStartValue,
				smallestStartValueIndex;

			// Gather all start values.
			$( '.daily_view_booking' ).each( function( index ) {
				let currentStartValue = parseInt( $( this ).data( 'bookingStart' ), 10 );

				if ( 'undefined' === typeof previousStartValue ) {
					previousStartValue = currentStartValue;
				}

				if ( currentStartValue <= previousStartValue ) {
					smallestStartValueIndex = index;
				}

				previousStartValue = currentStartValue;
			} );

			/*
			 * Keep running at interval until first booking
			 * offset is found to prevent race condition.
			 */
			let findFirstBooking = setInterval( function() {
				let firstBookingTopOffset = parseInt( $( '.daily_view_booking' ).eq( smallestStartValueIndex ).offset().top, 10 );

				if ( firstBookingTopOffset > 0 ) {
					$( 'html, body' ).animate( {
						scrollTop: firstBookingTopOffset - 110
					}, 600 );

					clearInterval( findFirstBooking );

				}
			}, 100 );

			/*
			 * Fallback timeout after 5 seconds to
			 * clear the interval so it doesn't continue
			 * running indefinitely.
			 */
			setTimeout( function() {
				clearInterval( findFirstBooking );
			}, 5000 );
		}
	}

	/*
	* Add select class on mouseenter and mouseleave events for each event with the same
	* event( Bookings booking or Google Calendar event ) ID
	*/
	$('.calendar_month_event').on(
		'mouseenter',
		function() {
			let id = this.dataset["id"];
			let id_class = '.calendar_event_id_' + id;
			$( id_class ).find( 'a.wc-bookings-event-link' ).addClass("calendar_month_event_selected");
		}
	).on(
		'mouseleave',
		function() {
			let id = this.dataset["id"];
			let id_class = '.calendar_event_id_' + id;
			$( id_class ).find( 'a.wc-bookings-event-link' ).removeClass("calendar_month_event_selected");
		},
	);

	let input = $.map( $( '.daily_view_booking' ), function ( el ) {
		return {
			id: $( el ).data( 'bookingId' ),
			start: $( el ).data( 'bookingStart' ),
			end: $( el ).data( 'bookingEnd' ),
		};
    } );

    let totalCalendarHeight = 1968; // definded by design
    let calendarHeightInMinutes = 1440; // 60 minutes * 24 hours
    let scale = totalCalendarHeight / calendarHeightInMinutes;

	processLayout( input, 1968, 100 ).forEach( function( node ) {
		let $el = $('*[data-booking-id="' + node.id + '"]');

        $el.css( { 'top':  'calc(' + node.top * scale + 'px + 2px )' } );
		$el.css( { 'height': 'calc(' + node.height * scale +'px - 3px )' } );
		$el.css( 'left', node.left + '%' );
		// 12px come from the popper padding
		$el.css( { 'width': 'calc(' + node.width + '% - 13px )' } );
		$el.show();
	}, scrollToFirstBooking() );

	let global_availability = $.map( $( '.daily_view_global_availabiltiy' ), function ( el ) {
		return {
			start: $( el ).data( 'start' ),
			end: $( el ).data( 'end' ),
			id: $ (el ).data( 'globalAvailabilityId' ),
		};
	});

	global_availability.forEach( function ( range ) {
		let $el = $( '*[data-global-availability-id="' + range.id + '"]' );
		$el.css({ 'top': 'calc(' + range.start * scale + 'px )' });
		$el.css({ 'height': 'calc(' + (range.end - range.start) * scale + 'px )' });
		$el.css( 'left', '-43px' );
		$el.css({ 'width': 'calc(' + '100' + '% + 50px )' });
		$el.show();
	});

	$( '.daily_view_booking' )
		.each( function( index, el ) {
			let $el = $( el );

			// Account for the padding in the CSS
			$el.height( $el.height() - 12 );
		} );

	// Scroll to today on schedule view.
	$( document ).ready( function() {
		const $today_el = $( '.wc-bookings-schedule-date.wc-booking-schedule-today' );
		if ( $today_el.length ) {
			const today_offset = parseInt( $today_el.offset().top, 10 );
			$( 'html, body' ).animate( {
				scrollTop: today_offset - 101, // today field/row height offset + floating header height
			}, 600 );
		}
	} );
} );
